import { render, staticRenderFns } from "./contactFooter.vue?vue&type=template&id=616bb32a&scoped=true&"
import script from "./contactFooter.vue?vue&type=script&lang=js&"
export * from "./contactFooter.vue?vue&type=script&lang=js&"
import style0 from "./contactFooter.vue?vue&type=style&index=0&id=616bb32a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616bb32a",
  null
  
)

export default component.exports